@if (dataSource) {
    <dx-select-box class="h-100"
                   [placeholder]="placeholderText"
                   [width]="420"
                   [items]="dataSource"
                   displayExpr="name"
                   [value]="input"
                   (valueChange)="onInputChanged($event)"
                   [grouped]="true">
        <div *dxTemplate="let item of 'item'"
             class="d-flex">
            {{ item.name }}
            @if (item.inputGroup) {
                <span class="ms-auto">
                    <b>{{ item.inputGroup.name }}</b>
                </span>
            }
        </div>
    </dx-select-box>
} @else {
    <div class="alert alert-light">Select a canvas first</div>
}
